import { render, staticRenderFns } from "./ConfigSmsMessagesList.vue?vue&type=template&id=000ff9a2&scoped=true&"
import script from "./ConfigSmsMessagesList.vue?vue&type=script&lang=js&"
export * from "./ConfigSmsMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSmsMessagesList.vue?vue&type=style&index=0&id=000ff9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ff9a2",
  null
  
)

export default component.exports